import { gastoniaConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function GastoniaPage() {
  return <CityPageTemplate config={gastoniaConfig} />;
}